<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          프리미엄 마켓
        </div>
        <div class="mb10">
          이미지 W X W 사이즈에 최적화 되어 있습니다.<br>
          저장버튼을 눌러야 배너가 반영됩니다. <br>
        </div>
        <div>
          <premium-file-component></premium-file-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PremiumFileComponent from "@/components/premium/PremiumFileComponent";

export default {
  name: "Premium",
  mixins: [],
  components: {
    PremiumFileComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>